export interface TableRow {
  videoCallId: number;
  clientId: number;
  client: string;
  sessionDate: string;
  scheduled: string;
  delivered: string;
  billable: string;
  billableUnitsLost: number;
}

export const PERIOD_FILTERS = {
  THIS_WEEK: "this_week",
  LAST_WEEK: "last_week",
  CUSTOM: "custom",
} as const;

export const UNIT_FILTERS = {
  HOURS: "hours",
  MINUTES: "minutes",
} as const;

export type PeriodFilter = (typeof PERIOD_FILTERS)[keyof typeof PERIOD_FILTERS];
export type UnitFilter = (typeof UNIT_FILTERS)[keyof typeof UNIT_FILTERS];
export type CustomDateRange = [Date | null, Date | null];
